import './PBFModalMassUpdate.style.less'

import { Alert, Modal, Tabs } from 'antd'

// import Property from './Property'
import Task from './Task'
import { WarningFilled } from '@ant-design/icons'
import { useState } from 'react'

interface Props {
  visible: boolean
  orderSelectedCount: number
  onClose: () => void
}

function PBFModalMassUpdate({ visible, orderSelectedCount, onClose }: Props) {
  const [orderSelected, setorderSelected] = useState<number>(orderSelectedCount)

  return (
    <Modal title="Mass Update" open={visible} onCancel={onClose} footer={null}>
      {orderSelected > 0 && (
        <Alert
          showIcon
          description={`You have selected ${orderSelected} orders. Only the same tasks and properties of these orders will be selectable.`}
          type="warning"
          icon={<WarningFilled />}
          className="alert-message"
        />
      )}
      <Tabs
        style={{ marginTop: orderSelected > 0 ? 24 : 0 }}
        items={[
          {
            label: 'Tasks',
            key: 'item-1',
            children: (
              <Task
                onChange={(value) => setorderSelected(value)}
                onClose={onClose}
              />
            ),
          },
        ]}
      />
    </Modal>
  )
}

export default PBFModalMassUpdate
